module.exports = __webpack_public_path__ + "img/Feature.4f2a53b0.png";